import React, { useEffect, useState } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import MealsConfig from "./meals_config";

const Meals = ({ selectedTermId, isExtra }) => {
  const refNameRoomConfig = isExtra ? "extra_room_configs" : "room_configs";
  const { watch } = useFormContext();
  const [shouldRender, setShouldRender] = useState(false);
  const roomCount = parseInt(watch("rooms.value"));
  const selectedRoomConfig1 = watch(`${refNameRoomConfig}.one.id`);
  const selectedRoomConfig2 = watch(`${refNameRoomConfig}.two.id`);

  useEffect(() => {
    setShouldRender((prev) => prev + 1);
    // console.log([roomCount, selectedRoomConfig1, selectedRoomConfig2]);
  }, [roomCount, selectedRoomConfig1, selectedRoomConfig2])

  return (
    <div id="order_meals_area">
      <div className="hidden">{shouldRender}</div>
      {selectedRoomConfig1 && (
        <MealsConfig
          number="one"
          isExtra={isExtra}
          selectedTermId={selectedTermId}
          selectedRoomConfigId={selectedRoomConfig1}
          key={`meal-config1-${selectedRoomConfig1}`}
        />
      )}
      {roomCount == 2 && selectedRoomConfig2 && (
        <MealsConfig
          number="two"
          isExtra={isExtra}
          selectedTermId={selectedTermId}
          selectedRoomConfigId={selectedRoomConfig2}
          key={`meal-config2-${selectedRoomConfig2}`}
        />
      )}
    </div>
  );
};

export default Meals;
